/* tslint:disable */
/**
 */
export class HistoricalSites {
    id?: number;
    company_id?: number;
    name?: string;
    position?: string;
    user_id?: number[];
    historical_sites_group_id?: number;
    /** Tọa độ GPS: gửi lên API khi lưu (lat / lng) */
    lat?: number;
    lng?: number;
    /** Phạm vi (mét) */
    radius_meters?: number;
    /** Từ API (read-only) */
    positions_lat?: number;
    positions_lng?: number;
    created_at?: string;
    updated_at?: string;
    page?: number;
    limit?: number;
}
